import React from 'react';
import styled from 'styled-components';
import { Border, BorderStyle, Text } from '../core';
import { fibonacci, Overlay, Padding, Queue, Center } from '../layout';
import { TypographyStyle } from '../typography';
import _ from 'lodash';

const RawInput = styled.input<any>`
  background-color: inherit;
  color: white;
  height: 100%;
  width: 100%;
  font-family: 'Apercu Pro', -apple-system, Helvetica, sans-serif;
  line-height: 0;
  box-sizing: border-box;
  ${BorderStyle}
  padding: ${({ theme, size }) =>
    !_.isArray(size)
      ? `${fibonacci(size) * theme.baseSpace}px`
      : size.map((d) => `${fibonacci(d) * theme.baseSpace}px`).join(' ')};

  ::placeholder {
    color: #939393;
  }
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Input = (props) => {
  let { placeholder, rightIcon } = props;
  return (
    <InputWrapper>
      <RawInput
        borderSize={[1]}
        borderRole="grey3"
        radius="small"
        size={[4]}
        placeholder={placeholder}
      />
      <Overlay top={0} right={5} height="100%">
        <Center>
          <Text textRole="secondary" textType="primary7">
            {rightIcon}
          </Text>
        </Center>
      </Overlay>
    </InputWrapper>
  );
};
